import React, { Component, Fragment } from 'react'
import { graphql, Link } from 'gatsby'
import PropTypes from 'prop-types'
import Lightbox from 'lightbox-react'
import { Wrapper } from '../../Container/Container.style'
import { SecondaryButton, ButtonArrow } from '../../../shared/Buttons/Buttons.styles'
import { TextWithBackgroundImage,
  YoutubeVideoWrapper } from './TextWithBackground.style'
import PlayButton from '../Icons/PlayButton'
import ArrowRight from '../Icons/ArrowRight'
import Image from '../../../shared/Image'
import 'lightbox-react/style.css'

const Video = (url, title) => (
  <YoutubeVideoWrapper
    title={title}
    src={url}
    width="700"
    height="500"
    frameBorder="0"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  />
)

export default class TextWithBackground extends Component {
  state = {
    isOpen: false,
  }
  render() {
    const {
      title,
      ctaLabel,
      ctaUrl,
      backgroundImage,
      description,
      enableVideo,
      youtubeVideoUrl,
    } = this.props

    const { isOpen } = this.state

    return (
      <Fragment>
        <TextWithBackgroundImage className="wow fadeInLeft" data-wow-duration="0.8s" data-wow-offset="80">
          <div
            className={`wrapper ${enableVideo ? 'videoContent' : ''}`}
            style={{
              backgroundImage: `url(${enableVideo
                ? backgroundImage.file.url : ''})`,
            }}
          >
            {enableVideo && (
              <Image
                src=""
                alt={backgroundImage.file.url}
                className="videoPoster"
              />
            )}
            <Wrapper>
              <div className={enableVideo && 'content'}>
                <h4>{title}</h4>
                {description && (
                  <div
                    className="productDescription"
                    dangerouslySetInnerHTML={{
                      __html: description.childMarkdownRemark.html,
                    }}
                  />
                )}
                {enableVideo && (
                  <svg
                    viewBox="0 0 88 88"
                    onClick={() =>
                      this.setState({
                        isOpen: true,
                      })
                    }
                  >
                    <PlayButton />
                  </svg>
                )}
              </div>

              {ctaUrl && ctaLabel && (
                <SecondaryButton>
                  <Link to={ctaUrl}>
                    {ctaLabel}
                    <ButtonArrow viewBox="0 0 12 21"><ArrowRight /></ButtonArrow>
                  </Link>
                </SecondaryButton>
              )}
            </Wrapper>
          </div>
        </TextWithBackgroundImage>
        {isOpen && (
          <Lightbox
            mainSrc={[Video(youtubeVideoUrl, title)][0]}
            enableZoom={false}
            clickOutsideToClose
            onCloseRequest={() =>
              this.setState({
                isOpen: false,
              })
            }
          />
        )}
      </Fragment>
    )
  }
}

export const TextWithBackgroundFragment = graphql`
  fragment TextWithBackgroundFragment on ContentfulTextWithBackground {
    title
    ctaLabel
    ctaUrl
    enableVideo
    youtubeVideoUrl
    backgroundImage {
      file {
        url
      }
    }
    description {
      childMarkdownRemark {
        html
      }
    }
  }
`

TextWithBackground.propTypes = {
  enableVideo: PropTypes.bool,
  title: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  youtubeVideoUrl: PropTypes.string,
  ctaUrl: PropTypes.string.isRequired,
  backgroundImage: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
  description: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string.isRequired,
    }),
  }),
}
TextWithBackground.defaultProps = {
  backgroundImage: null,
  description: null,
  enableVideo: false,
  youtubeVideoUrl: null,
}
